import { Box, FormHelperText, Grid2, Typography } from '@mui/material';
import { QRCodeSVG } from 'qrcode.react';
import type { FC } from 'react';
import { AvaniButton } from '../../Buttons';
import { InputFormControl } from '../../FormComponents';

interface TotpSetupFormProps {
  register: any;
  errors: any;
  loading: boolean;
  handleSubmit: any;
  setupUri: string;
}

export const TotpSetupForm: FC<TotpSetupFormProps> = ({ loading, register, errors, handleSubmit, setupUri }) => {
  return (
    <form onSubmit={handleSubmit}>
      <Box className="form-container" display="flex" justifyContent="center">
        <Grid2 container spacing={2} width={400} mt={2} rowSpacing={3}>
          <Grid2 size={{ xs: 12 }} display="flex" justifyContent="center">
            <QRCodeSVG value={setupUri} size={180} />
          </Grid2>
          <Grid2 size={{ xs: 12 }}>
            <Typography variant="body2" color="text.secondary" textAlign="center">
              Scan the QR code with your authenticator app, then enter the 6-digit code below.
            </Typography>
          </Grid2>
          <Grid2 size={{ xs: 12 }}>
            <Typography variant="body2" color="text.secondary" textAlign="center">
              Activating 2FA will disable OTP login option. User will be required to enter password and authenticator
              code during login.
            </Typography>
          </Grid2>
          <Grid2 size={{ xs: 12 }}>
            <InputFormControl
              label="Authenticator code"
              id="code"
              fullWidth={true}
              registerProps={register('code')}
              error={errors?.code?.message}
              type="text"
            />
          </Grid2>
          <Grid2 textAlign="right" size={{ xs: 12 }}>
            {errors?.root && (
              <FormHelperText error id="helper-text-root">
                {errors?.root?.message}
              </FormHelperText>
            )}
          </Grid2>
        </Grid2>
      </Box>
      <Box className="form-container">
        <Grid2 container spacing={2} width={400}>
          <Grid2 textAlign="right" size={{ xs: 12 }}>
            <AvaniButton loading={loading} type="submit" label="Activate" />
          </Grid2>
        </Grid2>
      </Box>
    </form>
  );
};
